export const SliderOrientation = {
  VERTICAL: 0,
  HORIZONTAL: 1,
};

export default {
  SliderOrientation,
};
